export enum ExternalBiosignsInvocatorApps {
    CHECKUPAPP = 'checkupApp',
    ONECAREAPP = 'onecareApp'
}
